import token from '@uipath/apollo-core/lib';
export const MuiInputBase = (palette) => {
    return {
        root: {
            '&.Mui-disabled': {
                color: palette.semantic.colorForegroundDisable,
                backgroundColor: palette.semantic.colorBackgroundDisabled,
                background: palette.semantic.colorBackgroundDisabled,
            },
        },
        input: {
            fontSize: token.FontFamily.FontMSize,
            fontFamily: token.FontFamily.FontNormal,
            '&.Mui-disabled': {
                color: palette.semantic.colorForegroundDisable,
                backgroundColor: palette.semantic.colorBackgroundDisabled,
                background: palette.semantic.colorBackgroundDisabled,
            },
        },
    };
};
